import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { G_ModelsViewModel } from 'src/app/viewmodels/g-settings/G_ModelsViewModel';
import { G_FuelTypeViewModel } from 'src/app/viewmodels/g-settings/G_FuelTypeViewModel';
import { G_BrandsViewModel } from 'src/app/viewmodels/g-settings/G_BrandsViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveVehicleModelRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.scss']
})
export class ModelComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  public itemVm: SaveVehicleModelRequest = new SaveVehicleModelRequest();
  public vmListItems: any = [];

  public component_Title = "Vehicle Model";
  public deleteId: string;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
  }


  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }

  ngAfterViewInit() {
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetVehicleModelsAsync().subscribe((res: any) => {
      this._jq.reinitDataTable(res.result);
      this.vmListItems = res.result;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    if (model !== undefined) {
      this.itemVm = new SaveVehicleModelRequest();
      this.itemVm.brand = new ItemViewModel1();
      this.itemVm.fuelType = new ItemViewModel1();
      this.itemVm = model;
      // this.itemVm.FK_G_FuelType_Id = new ItemViewModel(model.FK_G_FuelType_Id.Id, model.FK_G_FuelType_Id.Name);
      // this.itemVm.Fk_G_Brand_Id = new ItemViewModel(model.Fk_G_Brand_Id.Id, model.Fk_G_Brand_Id.Name);

    } else {
      this.itemVm = new SaveVehicleModelRequest();
    }
    this.openModal(template, 1);
  }



  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this._uow.gSettingService.DeleteVehicleModelAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.itemVm = new SaveVehicleModelRequest();
      this.getList();
    }
  }
}
